module.exports = __webpack_public_path__ + "img/banner2.61ae872.jpg";